import { ChangeEvent, MouseEvent, ReactElement, useState } from "react";
import { AnnotationActions, AnnotationColors, AnnotationTypes } from "../../../shared/constants";
import { IAnnotationData } from "../../../shared/types";
import "./styles.scss";

interface INotesPopup {
  onAnnotationResponse: (annotation: IAnnotationData) => void;
  toggleNotesPopup: (visibility: boolean) => void;
  annotation: IAnnotationData;
}

export const NotesPopup = ({
  annotation,
  onAnnotationResponse,
  toggleNotesPopup,
}: INotesPopup): ReactElement => {
  const [isShareable, setIsShareable] = useState<boolean | undefined>(annotation.shareable);
  const [notesPopupText, setNotesPopupText] = useState<string | undefined>(annotation.noteText);

  const isNewNote = (): boolean => !annotation.noteText;

  const handleChange = (event: ChangeEvent<HTMLTextAreaElement>): void => {
    setNotesPopupText(event.target.value);
  };

  const onSave = (): void => {
    const updatedAnnotation = {
      ...annotation,
      color: isShareable ? AnnotationColors.Blue : AnnotationColors.Yellow,
      noteText: notesPopupText,
      annotationType: AnnotationTypes.Highlight,
      actionType: annotation.annotationId ? AnnotationActions.Edit : AnnotationActions.Add,
      shareable: isShareable,
    };

    onAnnotationResponse(updatedAnnotation);
    toggleNotesPopup(false);
  };

  const onDelete = (): void => {
    annotation.actionType = AnnotationActions.Delete;

    onAnnotationResponse(annotation);
    toggleNotesPopup(false);
  };

  const hideNotesPopup = (event: MouseEvent): void => {
    event.preventDefault();

    if (event.target === event.currentTarget) {
      toggleNotesPopup(false);
    }
  };

  const handleToggleChange = () => {
    setIsShareable(!isShareable);
  };

  return (
    <div className="popup-container" onClick={hideNotesPopup}>
      <div className="notes-popup">
        <h4>
          {isNewNote() ? <span>Create Note</span> : <span>Edit Note</span>}
          <span
            className="close-button"
            onClick={(): void => {
              toggleNotesPopup(false);
            }}
          >
            Close
          </span>
        </h4>

        <textarea
          placeholder="notes text"
          id="note_text"
          value={notesPopupText}
          onChange={handleChange}
        />

        <div className="toggle">
          <label>Share</label>
          <div className={`switch ${isShareable ? "checked" : ""}`} onClick={handleToggleChange}>
            <div className="knob" />
          </div>
        </div>

        <div className="action-buttons">
          <button disabled={!notesPopupText} onClick={onSave}>
            Save
          </button>
          {!isNewNote() && <button onClick={onDelete}>Delete</button>}
        </div>
      </div>
    </div>
  );
};
